module.exports = __webpack_public_path__ + "img/RothscH.3b99ce41.jpg";